import * as React from 'react'

import { Container } from 'components/Layout'
import Page from 'components/Page'
import PageHeader from 'components/Page/PageHeader'
import { Crumbs } from 'components/BreadCrumbs'
import { ContactsList } from 'features/Contacts/ContactsList'

export interface IContactsProps {
  location: {
    query: {
      page?: string
      search?: string
    }
  }
}

export class Contacts extends React.Component<IContactsProps> {
  render() {
    const { location } = this.props
    return (
      <Page layout={{ header: 'app' }} title="Contacts">
        <PageHeader>
          <Crumbs title="Contacts" />
        </PageHeader>
        <Container paddingTop paddingBottom>
          <ContactsList
            page={parseInt(location.query.page || '1', 10)}
            search={location.query.search}
          />
        </Container>
      </Page>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/Contacts/Contacts.tsx